import { createAction } from '@reduxjs/toolkit';

import { ChangeLayoutVariantPayload } from '@definitions/artists.types';

const PREFIX = 'ARTISTS';

export const changeLayoutVariant = createAction<ChangeLayoutVariantPayload>(`${PREFIX}/CHANGE_LAYOUT_VARIANT`);
